import { Box, BoxProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  onClick: () => void;
  boxProps?: BoxProps;
};

export const ClickableText = (props: Props) => {
  return (
    <Box
      userSelect={'none'}
      cursor={'pointer'}
      fontStyle={'italic'}
      fontWeight={'bold'}
      color={'#003470'}
      fontSize={'xs'}
      onClick={props.onClick}
      {...props.boxProps}>
      {props.children}
    </Box>
  );
};
